import { useLang } from 'hooks/lang';

import { isLeader, LoadResults } from 'entities';

import { UsersIcon } from 'components/Icons';

import { useTeam } from 'providers/Team';
import { InvoiceTeamUser } from './TeamUser';
import { ItemGroup } from '../../ItemGroup';

import { useUser } from 'hooks';
import { compareByName, sortByProperty } from 'utils/array';
import { hasWarning } from './utils';
import { useMemo } from 'react';

interface InvoiceTeamOverviewProps {
  teamControls: LoadResults['invoice.invoiceControlByUsers'];
}

export function InvoiceTeamOverview({ teamControls }: InvoiceTeamOverviewProps) {
  const loggedUser = useUser();
  const { teamUsers } = useTeam();

  const { t } = useLang();

  const addWarning = useMemo(
    () =>
      hasWarning(
        Object.values(teamControls)
          .map((c) => c.controls)
          .flat(),
      ),
    [teamControls],
  );

  if (!isLeader(loggedUser)) return null;

  return (
    <ItemGroup
      name={t('my-team')}
      icon={<UsersIcon size={22} />}
      items={teamUsers.filter(({ id }) => id !== loggedUser.id)}
      itemKey="id"
      itemClassName="p-2"
      addErrorIndication={addWarning}
      render={(entry) => (
        <InvoiceTeamUser
          user={entry}
          key={`${entry.id}-side-bar-view`}
          controls={sortByProperty(teamControls[entry.id]?.controls ?? [], ['status', 'project'], {
            project: compareByName,
          })}
        />
      )}
    />
  );
}
